export function partnersFilter() {
    $(".partners-filter-toggle").on("click", function (event) {
        event.preventDefault();
        $(this).toggleClass("active");
        $(".partners-filter-items").toggleClass("active");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/partners-filter.js